export const name = '$gzWalkMe';

/**
 * @ngdoc service
 * @name gazelle.components.walkme.service:$gzWalkMe
 *
 * @description
 * The $gzWalkMe service provides a way of interacting with the WalkMe snippet and API.
 */
export default function $gzWalkMe($window, $log, $q, rnTutorial) {
  //noinspection BadExpressionStatementJS
  'ngInject';
  let vm = this;

  const US_LANG = 'en-US';
  const WALK_ME_API_NAME = 'WalkMeAPI';
  const WALK_ME_STARTED_LOADING_MSG = `${WALK_ME_API_NAME}: started loading.`;
  const WALK_ME_READY_MSG = `${WALK_ME_API_NAME}: ready!`;
  const WALK_ME_STARTING_MSG = id => `Starting walkme id: ${id}`;

  activate();

  return {
    setupHeader,
    changeLanguage,
    startWalkthru,
    startWalkMeByTitle
  };

  /**
   * This function injects the WalkMe snippet on the head of the html, except if the WalkMeAPI loaded already or
   * is loading.
   * - If the WalkMeAPI loaded already, it will be resolved in the promise right away.
   * - If the WalkMeAPI is loading, this function will keep polling until the WalkMeAPI finishes loading or it will fail
   * in case of taking longer than a predefined timeout.
   * - If the WalkMeAPI was loaded by other component or if the WalkMeAPI is loading (and this was started outside of
   * this function), this function will not be able to identify this and it will inject the snippet again.
   * @returns {Promise}
   */
  function setupHeader() {
    const deferred = $q.defer();
    // Check if someone already load the WalkMeAPI to the global scope
    if (isLoaded()) {
      deferred.resolve($window.WalkMeAPI);
      return deferred.promise;
    }

    $log.log(WALK_ME_STARTED_LOADING_MSG);

    let otherWalkmeCallback;
    if (typeof $window.walkme_ready === 'function') {
      otherWalkmeCallback = $window.walkme_ready;
    }

    $window.walkme_ready = () => {
      $log.log(WALK_ME_READY_MSG);
      deferred.resolve($window.WalkMeAPI);

      if (otherWalkmeCallback) {
        otherWalkmeCallback();
      }
    };

    return deferred.promise;
  }

  function changeLanguage(locale) {
    if (isLoaded() && !!locale) {
      const localeValue = !locale.value || locale.value.startsWith('en') ? '' : locale.value;
      $window.WalkMeAPI.changeLanguage(localeValue);
    }
  }

  function startWalkthru(walkMeId) {
    if (isLoaded()) {
      safeStartWalkthru($window.WalkMeAPI, walkMeId);
    } else {
      setupHeader().then(WalkMeAPI => safeStartWalkthru(WalkMeAPI, walkMeId));
    }
  }

  function activate() {
    setupHeader();
  }

  function isLoaded() {
    return !!$window.WalkMeAPI;
  }

  function safeStartWalkthru(WalkMeAPI, walkMeId) {
    $log.debug(WALK_ME_STARTING_MSG(walkMeId));
    let walkmeStarted = WalkMeAPI.startWalkthruById(parseInt(walkMeId));
    return walkmeStarted ? walkmeStarted : WalkMeAPI.startFlowById(walkMeId);
  }

  function startWalkMeByTitle(title) {
    return rnTutorial.getByTitle(title, 'walkthruweb').then(walkMe => {
      if (walkMe) {
        startWalkthru(walkMe.content.trim());
      }
      else {
        return $q.reject();
      }
    });
  }
}
